import React from 'react';
import { availableThemes, normalizeTheme } from '../Core/Config';




// Funkce pro získání aktuálních nastavení
export const getTheme = () => {
    const savedTheme = localStorage.getItem('quizTheme');
    return normalizeTheme(savedTheme);
};

const SwitchTheme = ({ onChange, activeTheme }) => {

    const changeTheme = (theme) => {
        onChange(theme);  
    };


/*
    const [theme, setTheme] = useState(() => {
        const savedTheme = localStorage.getItem('quizTheme');
        return savedTheme ? savedTheme : initTheme;
    });


    // Funkce pro uložení do localStorage
    const saveTheme = (newTheme) => {
        localStorage.setItem('quizTheme', newTheme);
    };
*/

    return (
        <div id="quiz-changeTheme">

            <div className="flex justify-between items-end">

                <div id="quiz-themeSwitch" className="flex flex-row items-center flex-wrap gap-2 !h-10">

                    {availableThemes && availableThemes.length > 0 ? (
                        availableThemes.map((theme) => (
                            <button
                                className={`btn-sm w-8 h-8 text-shadow btn-${theme} ${activeTheme === theme ? 'active' : ''}`}
                                key={`set-theme-${theme}`}
                                onClick={() => changeTheme(theme)}
                            >
                            </button>
                        ))
                    ) : (
                        <p>Nebylo nalezeno žádné téma.</p>
                    )}
                </div>

            </div>       

             
          

 

        </div>
        
    );
};

export default SwitchTheme;
